import Vue from 'vue'
import {get} from 'lodash'

Vue.config.productionTip = process.env.NODE_ENV === 'production'

import router from './router'
import store from './store'
import App from './App.vue'

//STYLES
import "./assets/less/style.less"

//SENTRY
import './sentry'

//FILTERS
import './filters'

//DIRECTIVES
import './directives'

//TRANSLATES
import './translates'

import globalMixin from './mixins/globalMixin'
Vue.mixin(globalMixin)

//SERVICES
import './services/setMetaConfigs'
import './services/supportCSS'

//RESIZE SENSOR
import ResizeSensor from './helpers/resizeSensor'
window.ResizeSensor = ResizeSensor

//FINGERPRINT

// Vue.prototype.$fingerprint = Fingerprint2;

//STORE INIT
store.dispatch('init')

//GLOBAL COMPONENTS INIT
import {init as initGlobalComponents} from './globalComponents'
initGlobalComponents({router, store})

//STATISTIC
import {noActionCheckStatistic} from '@/services/statistic'
noActionCheckStatistic()

export const eventBus = new Vue()
Vue.prototype.$eventBus = eventBus;

Vue.prototype.$get = get

//REFERRERS
import {setReferrers} from '@/services/referrers'
setReferrers()

//MODALS AUTO SHOW
import modalsAutoShow from '@/services/modalsAutoShow'
modalsAutoShow(Vue)

export default new Vue({
  router,
  store,
  render: h => h(App)
})
